import React from 'react';
import PropTypes from 'prop-types';
import { productionTechnology } from '../../constants/parameters';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';

const ProductionTechnologyTable = ({
  dataSource,
  t,
  deleteClassifier,
  showModal,
}) => {
  const columns = [
    {
      title: t('tableGeneral.code'),
      dataIndex: productionTechnology.CODE,
    },
    {
      title: t('tableGeneral.en'),
      dataIndex: [productionTechnology.LANG, productionTechnology.ENGLISH],
    },
    {
      title: t('tableGeneral.et'),
      dataIndex: [productionTechnology.LANG, productionTechnology.ESTONIAN],
    },
    {
      title: t('tableGeneral.actions'),
      render: (value) => (
        <TableRowActions>
          <Button
            shape="circle"
            icon={<EditOutlined />}
            size="small"
            type="primary"
            onClick={() => showModal(value[productionTechnology.CODE])}
          />
          <span className="ant-divider" />
          <Popconfirm
            title={t('popconfirm.title')}
            onConfirm={() => deleteClassifier(value[productionTechnology.CODE])}
            okText={t('popconfirm.buttonYes')}
            cancelText={t('popconfirm.buttonNo')}
          >
            <Button
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
              type="primary"
            />
          </Popconfirm>
        </TableRowActions>
      ),
    },
  ];

  return (
    <Table
      rowKey={productionTechnology.CODE}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

ProductionTechnologyTable.propTypes = {
  dataSource: PropTypes.array,
  t: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

export default ProductionTechnologyTable;
